import React from 'react'
import EventsList from '../components/EventsList'

export const Events = ({ events }) => <EventsList events={events} />

export default Events
